import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from '../css/Error.module.css';
import * as CONSTANTS from '../../../constants/constants';
import { Layout, Button } from 'antd';
import * as Module from '../../../modules/core/menuModule';
import { isPrimeMenu } from "../../../modules/core/menuModule";


const { Content } = Layout;

export const FormMessage = () => {

  let history = useHistory();
  const isPrime = useSelector(isPrimeMenu);
  
  // ログアウト処理
  async function logout() {
    try {
      // ログアウト処理を呼び出す
      await Module.logout();
    } catch (error) {
      // 処理なし
    } finally {
      // 利用終了画面に遷移
      history.push(CONSTANTS.PATH_USE_END);
      return <></>;
    }
   }
  
  return (
    <Content>
      <div className={styles.border}></div>
      <br />
      <br />
      <div className={styles.contactFormTopMessage}>スキルマップサイトについてわからないことがあれば、下記までお気軽にお問い合わせください。</div>
      <a href={CONSTANTS.URL_CONTACT_FORM} target="_blank" rel="noopener noreferrer" className={styles.contactFormPageLink}>お問い合わせフォーム</a>
      <div className={styles.contactFormBottomMessage}>※お問い合わせは24時間フォームから送信可能ですが、窓口からの返信は下記の時間内となります。</div>
      <div className={styles.subMessage}>【スキルマップサイト運用窓口】対応時間：月～金 午前9:00 ～ 午後6:00（18:00）</div>
      <br />
      <Button
        className={isPrime ? styles.primeSysButton : styles.sysButton}
        onClick={logout}
      >
        閉じる
      </Button>
      <br />
      <br />
    </Content>
  )
}